/* eslint-disable no-unused-vars */
/* global RevolutCheckout */
import { getOptionsFromDataset } from '../../../util/dom.js';

/**
 * Revolut pay handler
 *
 * @this {HTMLElement}
 * @param {JQuery.TriggeredEvent} e
 */
const revolutPayHandler = async function (e) {

	e.preventDefault();

	const $trigger = $(this);
	const targetIsForm = $trigger.is('form');
	let $submitButton;
	let $paymentForm;
	let payOptions;
	const extraOptions = $trigger.data() || {};

	// Save order XHR, and return payment data
	const saveOrderPayment = async function () {
		const form_values = new FormData($paymentForm[0]);
		form_values.append('form_name', $paymentForm.prop('name'));

		const raw_response = await fetch(mpro.config.routes.checkout_order, {
			method: 'POST',
			body: form_values,
			'headers': {
				'X-Requested-With': 'XMLHttpRequest',
			},
		});

		const payment_response = await raw_response.json();
		return payment_response;
	};

	// Target element is a form
	if (targetIsForm) {
		$paymentForm = $trigger;
		$submitButton = $trigger.find('button[type=submit]');
		payOptions = getOptionsFromDataset($paymentForm[0], 'revolut', true);
	}
	// Target element is a button/link, but always in a form
	else {
		$submitButton = $trigger;

		// Send the whole parent form (or selected form)
		if ('revolutForm' in extraOptions) {
			// Select form by id of current form
			$paymentForm = extraOptions.applePayForm && (typeof extraOptions.applePayForm === 'string' && extraOptions.applePayForm !== '') ? $(extraOptions.applePayForm) : $trigger.closest('form');

			if ($paymentForm.length === 0) {
				console.warn('Could not find form target for \'revolut\' action', extraOptions.cartAddForm);
				return;
			}

			payOptions = getOptionsFromDataset($paymentForm[0], 'revolut', true);
		}
		// Send only data provided in the link/button (item data cannot be mixed with form-data)
		else {
			payOptions = getOptionsFromDataset($submitButton[0], 'revolut', true);
		}
	}

	mpro.addButtonLoading($submitButton);

	// Try to save order
	const payment_response = await saveOrderPayment();
	const { order, errors, payment_data, success_url } = payment_response;

	if (errors) {
		const error_message = errors.map( err => err.message ).join(' ');
		// return showErrorMessage(error_message);
		// Show error message
		mpro.toast('error', error_message);
		mpro.removeButtonLoading($submitButton);
		return;
	}

	// @ts-ignore
	const RC = await RevolutCheckout(payment_data.token, (payOptions.config.sandbox ? 'sandbox' : 'prod'));

	RC.payWithPopup({
		name: order.billing_name,
		email: order.customer_email,
		phone: order.billing_phone,
		// billingAddress: {
		// 	countryCode: order.billing_country_code,
		// 	region: order.billing_state,
		// 	city: order.billing_city,
		// 	streetLine1: order.billing_address,
		// 	// streetLine2: data.get("streetLine2"),
		// 	// postcode: order.billing_postal_code,
		// },
		upsellBanner: false,
		onSuccess() {
			// Redirect to after-checkout
			mpro.setLocation(success_url);
		},
		onError(error) {
			console.log(error.message);
			// Show error message
			mpro.toast('error', mpro.langvar('error_pay_processing') + " " + error.message );
			mpro.removeButtonLoading($submitButton);
		},
		onCancel() {
			mpro.removeButtonLoading($submitButton);
		},
	});
};

// Add init function that is executed only on first dom-ready (it should contain only document/body delegate handlers)
// @ts-ignore
mpro.addInitDelegate(($) => {

	const $B = mpro.get$B();

	// Handle click event for add-to-cart buttons
	$B.on('click.revolut', 'a[data-revolut],button[data-revolut],div[data-revolut],span[data-revolut],a[data-revolut-form],button[data-revolut-form],div[data-revolut-form],span[data-revolut-form]', revolutPayHandler);
	// Form only
	$B.on('submit.revolut', 'form[data-revolut]', revolutPayHandler);

	/**
	 * @this {any}
	*/
	const toggleData = function () {

		const $this = $(this);
		const $paymentForm = $this.closest('form');
		const $submitButton = $paymentForm.find('button[type=submit]');

		if ($this.data('paymentHandler') === 'revolut') {
			$paymentForm.attr('data-revolut', '');
			$submitButton.attr('data-revolut-form', '');
			$paymentForm.attr('data-revolut-config', $this.attr('data-payment-config'));
		}
		else {
			$paymentForm.removeAttr('data-revolut');
			$submitButton.removeAttr('data-revolut-form');
			$submitButton.removeAttr('data-revolut-config');
		}
	};

	$B.on('change.revolut', 'input[type=radio][name*="checkout"][name*="[payment_method][value]"]', function () {
		toggleData.call(this);
	});

	if ($('input[type=radio][name*="checkout"][name*="[payment_method][value]"]:checked').length > 0) {
		toggleData.call($('input[type=radio][name*="checkout"][name*="[payment_method][value]"]:checked')[0]);
	}

});

